
import { useContext } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { RedirectContext } from 'context/Redirect';
import { UserContext } from 'context/User';
import { useEffectOnce } from 'hooks/useEffectOnce';
import { signUpRoutes } from 'pages/SignUp/routes';
import { FaroRoutes } from 'utils/faro';
import { useHistory } from 'utils/router';

import { CheckInbox } from './CheckInbox';
import { Recover } from './Recover';
import { forgotPasswordRoutes } from './routes';

export const ForgotPassword = () => {
  const [{ instance, to }, { redirectToStateInstanceHome, redirectToPortal, redirectToTo }] =
    useContext(RedirectContext);
  const [
    {
      userMeta: { userIsLoggedIn, userHasConfirmedEmail },
    },
  ] = useContext(UserContext);
  const history = useHistory();

  useEffectOnce(() => {
    if (userIsLoggedIn) {
      if (!userHasConfirmedEmail) {
        history.push(signUpRoutes.checkInbox);
      } else if (to) {
        redirectToTo();
      } else if (instance) {
        redirectToStateInstanceHome();
      } else {
        redirectToPortal();
      }
    }
  });

  if (userIsLoggedIn) {
    return null;
  }

  return (
    <FaroRoutes>
      <Route path={forgotPasswordRoutes.relative.recover} element={<Recover />} />
      <Route path={forgotPasswordRoutes.relative.checkInbox} element={<CheckInbox />} />
      <Route index element={<Navigate replace to={forgotPasswordRoutes.recover} />} />
    </FaroRoutes>
  );
};
